/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {Link, withRouter} from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import usePersistentStore from "../../persistentStore";
import * as STATES from "../../constants/states";
import ReactResizeDetector from 'react-resize-detector';
import {tellParentMessage} from "../../utils/utils";

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(0),
    },
    submit: {
        margin: 0,
    },
    links: {
        marginTop: theme.spacing(1)
    },
    rightLink: {
        textAlign: 'right',
    },
    sectionTitle: {
        marginTop: theme.spacing(0),
    }
}));

const INITIAL_STATE = {
    firstName: '',
    lastName: '',
    email: '',
    passwordOne: '',
    passwordTwo: '',
    error: null,
};

const SignUp = props => {
    const classes = useStyles();
    const [state, setState] = useState(INITIAL_STATE);
    // eslint-disable-next-line no-unused-vars
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();

    const onSubmit = event => {
        firebase.auth().createUserWithEmailAndPassword(state.email, state.passwordOne)
            .then(authUser => {
                globalPersistentActions.setState(STATES.LOGGING_IN);
                globalPersistentActions.setFirstName(state.firstName);
                globalPersistentActions.setLastName(state.lastName);
            }).then(result => {
                setState({...INITIAL_STATE});
            }).catch(error => {
                globalPersistentActions.setState(STATES.LOGGING_OUT);
                setState({error});
            });
        event.preventDefault();
    };

    const onChange = event => {
        setState({
            ...state,
            [event.target.name]: event.target.value
        });
    };

    useEffect(() => {
        globalPersistentActions.clearStorage()
    }, []);

    const isInvalid =
        state.passwordOne !== state.passwordTwo ||
        state.passwordOne === '' ||
        state.email === '' ||
        state.firstName === '' ||
        state.lastName === '';

    const onResize = (w, h) => {
        tellParentMessage({contentHeight: h}, globalPersistentState.popupQueryObj)
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline/>
            <div className={classes.paper}>
                <Typography component="h6" variant="h6" className={classes.sectionTitle}>
                    Sign up
                </Typography>
                <form className={classes.form} noValidate onSubmit={onSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                autoComplete="fname"
                                name="firstName"
                                variant="outlined"
                                required
                                fullWidth
                                onChange={onChange}
                                id="firstName"
                                label="First Name"
                                placeholder="First Name"
                                autoFocus
                                margin="dense"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                onChange={onChange}
                                id="lastName"
                                label="Last Name"
                                placeholder="Last Name"
                                name="lastName"
                                autoComplete="lname"
                                margin="dense"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                onChange={onChange}
                                id="email"
                                label="Email Address"
                                placeholder="Email Address"
                                name="email"
                                autoComplete="email"
                                margin="dense"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                onChange={onChange}
                                name="passwordOne"
                                label="Password"
                                placeholder="Password"
                                type="password"
                                id="passwordOne"
                                autoComplete="current-password"
                                margin="dense"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                onChange={onChange}
                                name="passwordTwo"
                                label="Confirm Password"
                                placeholder="Confirm Password"
                                type="password"
                                id="passwordTwo"
                                margin="dense"
                            />
                        </Grid>
                    </Grid>
                    <Button
                        id={"sign-up"}
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={isInvalid}
                        className={classes.submit}
                    >
                        Sign Up
                    </Button>
                    <Grid container spacing={0} className={classes.links}>
                        <Grid item xs className={classes.rightLink}>
                            <Link to={"/sign-in"} variant="body2">
                                {"Already have an account? Sign in"}
                            </Link>
                        </Grid>
                    </Grid>
                    {state.error && <p>{state.error.message}</p>}
                </form>
            </div>

            <ReactResizeDetector handleWidth handleHeight onResize={onResize} />
        </Container>
    );
};

export const SignUpLink = () => (
    <Link to={"/sign-up"} variant="body2">
        {"No account? Sign Up"}
    </Link>
);

export default withRouter(SignUp);
